import { ClickAwayListener, Popper } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { BPMSoundsGeneric } from '../../../generic';
import { EditGrid } from './Grid';
var EditGridSelectKey = function (props) {
    var _a = useState([]), keys = _a[0], setKeys = _a[1];
    var _b = useState(false), open = _b[0], setOpen = _b[1];
    useEffect(function () {
        setOpen(!props.closed);
    }, [props.closed]);
    useEffect(function () {
        if (!props.closed && keys.length == 0)
            BPMSoundsGeneric.get().loadKeys().then(function (keys) {
                setKeys(keys.reduce(function (prev, current) {
                    var name = current.substr(0, 1);
                    var existing = prev.find(function (n) { return n.name == name; });
                    if (!existing) {
                        existing = { name: name, items: [] };
                        prev.push(existing);
                    }
                    existing.items.push({ name: current, id: current });
                    existing.items.sort(function (i1, i2) {
                        return i1.name.localeCompare(i2.name);
                    });
                    return prev;
                }, []).sort(function (i1, i2) {
                    return i1.name.localeCompare(i2.name);
                }));
            });
    }, [props.closed]);
    if (!keys || keys.length == 0) {
        return null;
    }
    return (React.createElement(Popper, { anchorEl: props.anchor, placement: 'left', open: open, modifiers: {
            flip: {
                enabled: true,
            },
            preventOverflow: {
                enabled: true,
                boundariesElement: 'window'
            }
        }, style: { zIndex: 400 } },
        React.createElement(ClickAwayListener, { mouseEvent: 'onClick', onClickAway: function () {
                props.onClosed(true);
            } },
            React.createElement("div", null,
                React.createElement(EditGrid, { items: keys, onItemClicked: function (key) {
                        props.onKeySelect(key);
                    } })))));
};
export default EditGridSelectKey;
//# sourceMappingURL=GridSelectKey.js.map